<script>
  import { Line } from 'vue-chartjs';

  export default {
    extends: Line,
    props: ['datasets', 'labels', 'options'],
    mounted() {
      const data = {
        labels: this.labels,
        datasets: this.datasets,
      };
      this.renderChart(data, this.options);
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/customized-components/LineChart.vue